import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../i18n'
import Nao from 'D:/tonebei/bot-nao/nao.js';

Vue.use(Vuex)


function set_lang(state, lang) {
	Nao.set_cur_dic(lang);
	state.language = lang;
	window.localStorage.setItem("language", lang);
}

export default new Vuex.Store({
	state: {
		language: null
	}, 
	mutations: {
		change_language (state, lang) {
			if (i18n.choose[lang]) set_lang(state, lang);
			else {
				import('../uilang/' + lang).then(function(e) {
					i18n.choose[lang] = e.default;
					set_lang(state, lang);
				});
			}
		},
	},
	actions: {
	},
	modules: {
	}
})
